import type { components } from "@/api/schema";

type RedemptionRow = components["schemas"]["RedemptionRow"];

const COLUMNS: (keyof RedemptionRow)[] = [
  "payment_date",
  "order_id",
  "status",
  "total_amount",
  "seller_id",
  "campaign_name",
  "promotion_name",
  "rule_sequence",
  "redeem_set",
  "gwp_sku",
  "gwp_quantity",
];

function escapeCsv(value: unknown): string {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Serialise redemption rows to CSV (header + rows). Mirrors reportToCsv. */
export function redemptionToCsv(items: RedemptionRow[]): string {
  const header = COLUMNS.join(",");
  const rows = items.map((item) => COLUMNS.map((col) => escapeCsv(item[col])).join(","));
  return [header, ...rows].join("\n");
}
